import { useEffect, useCallback } from 'react';

import useSocket from './useSocket';

/**
 * Custom Hook that listens to event and fires callback on event
 * The hook will remove the event in the cleanup phase on listen again if the event changes
 * @param event The event you want to listen for
 * @param fn Callback that fires on the event
 * @param deps (optional) Dependency list for `useCallback`
 * @returns the function wrapped in useCallback if 'deps is provided. otherwise it will just return the callback
 */
const useOn = <T extends (...args: any[]) => any>(event: string, fn: T, deps?: React.DependencyList): T => {

	const socket = useSocket();

	useEffect(() => {
		socket.on(event, fn);

		return () => {
			socket.off(event, fn);
		};
	}, [event]);

	const memoizedFn = useCallback<T>(fn, deps || []);

	return deps ? memoizedFn : fn;
};

export default useOn;